<template>
	<div>
		<mainDiv :info="block" />
	</div>
</template>

<script>
	import mainDiv from '@/components/moments/main'

	export default {
		props:{
			block:{
				required:false,
				type:Object
			}
		},
		components: {
			mainDiv
		},
		created(){
			this.$emit('headerCur',3);
		}
	}
</script>

<style>
</style>
